var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"dispatch-workflows-empty-state"}},[_c('div',{staticClass:"content"},[_vm._v("Please Select a Work Order to View")])])
}]

export { render, staticRenderFns }